import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import AgentItem from "components/AgentItem/AgentItem";

import { getToken } from "services/token-service/token.service";
import { useGetAgents } from "services/hooks/useGetAgents";
import { useGetSearchedAgents } from "services/hooks/useGetSearchedAgents";

import "./Agents.scss";
import { useSocket, wsEvents } from "../../../../../hooks/useSocket";
import NotificationSound from "../../../../../assets/sounds/notifySound.mp3";

const Agents = () => {
  const agentListRef = useRef();
  const token = getToken();
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [agents, setAgents] = useState([]);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const searchString = urlParams.get("search");

  const { data: agentsData, isFetched } = useGetAgents();
  const { mutate: searchAgents } = useGetSearchedAgents();
  const sound = new Audio(NotificationSound);
  sound.volume = 0.5;
  useEffect(() => {
    isFetched && !searchString && setAgents(agentsData);
    isFetched && setHasMore(true);
  }, [isFetched, agentsData, searchString]);

  useEffect(() => {
    const searchData = {
      category: "archive",
      searchString,
      page: page || "1",
    };
    searchString &&
      searchAgents(searchData, {
        onSuccess: (res) => {
          setAgents((prev) => (prev ? [...prev, ...res.data] : res.data));
          setHasMore(page < res.meta.last_page);
        },
      });
  }, [searchString, page, searchAgents]);
  useSocket({
    type: wsEvents.AGENT_ONLINE,
    callBack: (payload) => {
      const userInQuestion = agents.find((user) => user.id === payload.user_id);
      userInQuestion &&
        setAgents((current) => {
          return current.map((obj) => {
            if (obj.id === payload.user_id) {
              return {
                ...obj,
                status: "online",
              };
            }
            return obj;
          });
        });
    },
  });
  useSocket({
    type: wsEvents.AGENT_OFFLINE,
    callBack: (payload) => {
      const userInQuestion = agents.find((user) => user.id === payload.user_id);
      userInQuestion &&
        setAgents((current) => {
          return current.map((obj) => {
            if (obj.id === payload.user_id) {
              return {
                ...obj,
                status: "offline",
              };
            }
            return obj;
          });
        });
    },
  });
  useEffect(() => {
    page > 1 &&
      axios
        .get(`/api/admin/messages/conversations/agents?page=${page}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          console.log("res ==> ", res);
          setAgents((prev) => [...prev, ...res.data.data]);
          setHasMore(page < res.data.meta.last_page);
        })
        .catch((error) => {
          console.log(error);
        });
  }, [page, token]);

  const onScroll = () => {
    if (agentListRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = agentListRef.current;
      if (Math.round(scrollTop) + clientHeight >= scrollHeight) {
        if (hasMore) {
          setPage((prevPage) => prevPage + 1);
          setHasMore(false);
        }
      }
    }
  };

  return (
    <div className="AgentsContainer" ref={agentListRef} onScroll={onScroll}>
      {agents?.map((item) => {
        return <AgentItem adminData={item} key={item.id} />;
      })}
    </div>
  );
};

export default Agents;
